import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalEventEmitter, ModalStatusEnum } from '../../../modal/modal-status.enum';
import { RefundModalContent } from '../../refund-modal-content.interface';

@Component({
  template: ''
})
export class RefundFailModalComponent implements OnInit {
  @Output() event = new EventEmitter<ModalEventEmitter>();
  @Input() public content: RefundModalContent;

  public errorMessage: string;

  constructor(protected bsModalRef: BsModalRef) {}

  ngOnInit() {}

  ngAfterViewInit() {}

  close(redirect: boolean = false) {
    this.event.emit({ state: redirect ? ModalStatusEnum.back : ModalStatusEnum.close });
    this.bsModalRef.hide();
  }
}
